module.exports = __webpack_public_path__ + "img/google_play_badge.a0a26a41.png";